export default { __schema: { types: [] } };
